// extracted by mini-css-extract-plugin
export default {"root":"_pb7nhL3"};